export default "__VITE_ASSET__CvFCQ6Ad__"